function f({
  property: n,
  mobileKey: o,
  pcKey: i,
  defaultValue: t
}) {
  if (typeof n == "string")
    return { [o]: n, [i]: n };
  function c(r) {
    if (n && Object.prototype.hasOwnProperty.call(n, r))
      return n[r];
    if (t && typeof t == "object" && r in t)
      return t[r];
    if (typeof t == "string")
      return t;
    throw new Error(`defaultValue에 ${r} 값이 없으므로 defaultValue를 설정해주세요`);
  }
  const s = c("mobile"), e = c("pc");
  return {
    [o]: s,
    [i]: e
  };
}
export {
  f as e
};
